module.exports = __webpack_public_path__ + "aa9ead8caebdba0be77432425d9252d9.svg";